import React from 'react'

import { PageLayoutContainer } from '../../../lib/page-layout-container'
import { isAdminDomain } from '../../../lib/currentDomain'
import { ReportsGeneratorWidget } from '../../features/reports-generator/ReportsGeneratorWidget'
import { AutomaticReportDeliveriesTable } from '../../../admin/features/automatic-report-deliveries-table/AutomaticReportDeliveriesTable'

export const ReportsPage = () => {
    return (
        <PageLayoutContainer>
            <ReportsGeneratorWidget />
            {isAdminDomain && <AutomaticReportDeliveriesTable />}
        </PageLayoutContainer>
    )
}
